import { useSortable } from "@dnd-kit/sortable";
import ActionListItem from "@/appComponents/Blocks/Composites/ActionListItem/ActionListItem";
import { Flex } from "@theorgchartdev/storybook";
import { LayoutControls } from "@/appComponents/Navigation/RightSidebar/BackgroundDisplay/LayoutControls";
import { useState } from "react";
import { chartModeTestId } from "@/appComponents/Navigation/RightSidebar/Utils/chartModeTestId";

export const LayoutSegment = props => {
  const { area, layoutIndex, layout, handleLayoutRemove, setLayout } = props;

  const { attributes, listeners, setNodeRef } = useSortable({
    id: `bgElement-${area}-${layoutIndex}`,
    data: { layout, area, layoutIndex }
  });

  const handleRemove = () => {
    handleLayoutRemove();
  };

  const [hovered, setHovered] = useState(false);

  return (
    <div
      ref={setNodeRef}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onBlur={() => setHovered(false)}
    >
      <Flex justifyContent={"flex-start"}>
        <ActionListItem
          padding={"0px"}
          customStyle={{ maxWidth: "40px" }}
          actions={[
            {
              dataTestId: chartModeTestId("sidebar", "background-elements-drag-btn"),
              active: true,
              iconName: "grip-dots-vertical",
              wrapperProps: { ...attributes, ...listeners }
            }
          ]}
        />
        <LayoutControls
          dataTestId={chartModeTestId("sidebar", "background-elements-layout-type-select")}
          variant={"compact"}
          direction={"row"}
          onChange={setLayout}
          value={layout}
        />
        <ActionListItem
          padding={"0px"}
          customStyle={{ maxWidth: "40px" }}
          actions={[
            {
              active: hovered,
              dataTestId: chartModeTestId("sidebar", "background-elements-delete-btn"),
              iconName: "trash-can",
              iconProps: { color: "error" },
              onClick: handleRemove
            }
          ]}
        />
      </Flex>
    </div>
  );
};
